import { createFolioSearchClient } from '../folioSearchClient';

export const dealSearch = createFolioSearchClient({
	additionalSearchParameters: {
		sort_by: 'createDate:desc',
	},
});
